import { User } from '../user/user';
import { Company } from '../company/company';

export class UserClient extends User {
	companies: Company[] = new Array<Company>();
}
